import React, { useState, useEffect, useRef } from "react";
import styles from "./PreviewLocation.module.scss";
import { ReactComponent as MoreInfoIcon } from "assets/svg/InformationIcon.svg";
import { ReactComponent as CrossIcon } from "assets/svg/x.svg";
import {
  TextField,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  List,
  ListItem,
  ListItemText,
  CircularProgress,
} from "@mui/material";
import { privateGet } from "services/privateRequest";
import { LOCATION } from "services/apiEndpoints";

// Function to fetch locations (replace with actual API call)
const fetchLocations = async (searchQuery) => {
  try {
    const data = await privateGet(LOCATION, {
      pageNumber: 1,
      limit: 10,
    });
    if (data?.data?.data.location?.length > 0) {
      const res = data?.data?.data?.location
        ?.map((e) => e?.name)
        .filter((location) =>
          location.toLowerCase().includes(searchQuery.toLowerCase())
        );
      return res;
    }
  } catch (err) {
    console.log(err);
  }
};

const PreviewLocation = (props) => {
  const [showIcon, setShowIcon] = useState(
    props?.data?.showInstructions || false
  );
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [locations, setLocations] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedLocation, setSelectedLocation] = useState(null);

  const debounceTimeout = useRef(null);

  // Fetch locations based on search query
  const handleSearch = async () => {
    setIsLoading(true);
    const fetchedLocations = await fetchLocations(searchQuery);
    setLocations(fetchedLocations);
    setIsLoading(false);
  };

  // Debounced search handler
  const handleSearchDebounced = (e) => {
    setSearchQuery(e.target.value);

    if (debounceTimeout.current) {
      clearTimeout(debounceTimeout.current);
    }

    debounceTimeout.current = setTimeout(() => {
      handleSearch();
    }, 500); // Delay for 500ms after typing stops
  };

  const handleLocationClick = (location) => {
    setSelectedLocation(location);
    setIsModalOpen(false); // Close the modal after selecting a location
  };

  // Initial location fetch
  useEffect(() => {
    const loadInitialLocations = async () => {
      setIsLoading(true);
      const fetchedLocations = await fetchLocations("");
      setLocations(fetchedLocations);
      setIsLoading(false);
    };
    loadInitialLocations();
  }, []);

  return (
    <div className={styles.mainContainer}>
      <div className={styles.mainContent}>
        <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
          <div className={styles.heading}>
            <span>
              {" "}
              {props?.data?.required && <span style={{ color: "red" }}>*</span>}
              {props?.data?.value || props?.name}
            </span>
          </div>
          {/* <div className={styles.iconContainer}> */}
          {/* Instruction Icon */}
          {props?.instructions || props?.data?.media?.length ? (
            <div>
              {showIcon ? (
                <CrossIcon onClick={() => setShowIcon((prev) => !prev)} />
              ) : (
                <MoreInfoIcon onClick={() => setShowIcon((prev) => !prev)} />
              )}
            </div>
          ) : null}

          {/* </div> */}
        </div>
        <div className={styles.locationContainer}>
          <Button
            variant="outlined"
            color="primary"
            onClick={() => setIsModalOpen(true)}
          >
            {selectedLocation || "Select Location"}
          </Button>
        </div>
      </div>

      {showIcon && (
        <div className={styles.subContent}>
          {props?.instructions && (
            <div className={styles.instructionText}>
              {props?.instructions}
            </div>
          )}
          {props?.data?.media?.length ? (
            <>
              {props?.data?.media.map((image) => (
                <img
                  className={styles.imageStyle}
                  src={image.path}
                  alt="Preview"
                />
              ))}
            </>
          ) : null}
        </div>
      )}

      {/* Modal to show location list */}
      <Dialog
        open={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle>Select a Location</DialogTitle>
        <DialogContent>
          {/* Search box */}
          <TextField
            label="Search Location"
            variant="outlined"
            fullWidth
            value={searchQuery}
            onChange={handleSearchDebounced} // Use debounced search
            margin="normal"
          />
          {/* Display loading indicator while fetching locations */}
          {isLoading ? (
            <div className={styles.loading}>
              <CircularProgress />
            </div>
          ) : (
            <List>
              {locations.map((location, index) => (
                <ListItem
                  button
                  key={index}
                  onClick={() => handleLocationClick(location)}
                >
                  <ListItemText primary={location} />
                </ListItem>
              ))}
            </List>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setIsModalOpen(false)} color="primary">
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default PreviewLocation;
